import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import EcoButton from 'eco-design/base/eco-button';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import useStatusCLang from '../../StatusC/useStatusCLang';
import ImgPreLoad from './ImgPreLoad';
import styled from './index.module.scss';
import FooterB from './FooterB';
import { useLang } from '@/i18n';

const FooterA = () => {
    const { t } = useLang('theProduct.BannerA');
    return (
        <div className="banner-bottom">
            <p className="banner-bottom-desc">{t('desc2')}</p>
            <div>
                <EcoButton
                    lHref="#Products"
                    lType="filled"
                    lSize="extra-large"
                    lRadius="ellipse"
                    lBgColor="#3F68E0"
                    lDataLayer={{
                        event: 'uaEvent',
                        event_name: 'click_anchor',
                        position: 'Win an Exclusive EcoFlow STREAM Offer only on the EcoFlow official online store!',
                        button_name: 'Pre-Order Now',
                    }}
                    lChildren={t('btn1')}
                />
            </div>
        </div>
    );
};

export default function Comp() {
    const { t } = useStatusCLang('theProduct.BannerA');
    const { pageStatus } = useProductStore();
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        theme: 'white',
        // heightType: 'full-screen',
        // isVideo: true,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1748401891431/PC_KV-2560.jpg',
        // pad: 'https://websiteoss.ecoflow.com/upload/image/1747113459735/kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1748401905333/M_KV-1023.jpg',
        label: pageStatus === IPageStatus.statusA ? t('label') : t('desc'),
        labelColor: '#fff',
        title: t('title'),
        subTitle: t('desc3'),
        subTitleColor: '#FF7100',
        titleColor: '#fff',
        childrenB: pageStatus === IPageStatus.statusA ? <FooterA /> : <FooterB />,
        // poster: 'https://websiteoss.ecoflow.com/upload/image/1744944316617/steam-kv.jpg',
        // posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744944487660/steam-kv-m.jpg',
    };
    return (
        <div id="banner" className={styled.banner}>
            <EcoBanner theme="black" {...dataA} />
            <ImgPreLoad />
        </div>
    );
}
